// extracted by mini-css-extract-plugin
var _1 = "_2Aig";
var _2 = "OagIA";
var _3 = "j0myv";
var _4 = "n2sWT";
export { _1 as "base", _2 as "header", _3 as "headerButton", _4 as "separator" }
